import React from 'react';
import './AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>MANAGING TRUSTEE</h1>
        <div className="yellow-line1"></div>
        <p>
We at PACE Group have always worked to provide excellent facilities and reasonable tuition to the community at large in order to provide high quality education. The P. A. College of Engineering holds the distinction of being PACE Group's first institution. The campus is located in Mangaluru, the centre of education for Karnataka, in a beautiful, eco-friendly and green hillside area. For the young minds entering our place of learning, the green surroundings fosters a very relaxing atmosphere. It also offers a fantastic opportunity for our young professionals and entrepreneurs to connect with the wildlife and flora that inhabits the Indian west coast.

Being the first private, NBA-accredited engineering institution in Mangaluru, P. A. College of Engineering has consistently upheld its high standards to preserve its leading position in the field. By producing a generation that is equipped with the knowledge, skills, and morals needed to compete in today's highly competitive national and worldwide marketplaces, we are firmly committed to improving society.

To keep up with industry standards and offer all the latest courses and amenities, we have continuously updated ourselves. Since the middle of the 20th century, there has been a digital revolution that is characterised by a fusion of technology that is obfuscating the boundaries between the physical, digital, and biological domains. In order to improve our students' skill sets and prepare them to actively participate in the revolution, we have developed courses like Artificial Intelligence and Machine Learning (AIML). By adding courses with an emphasis on Internet of Things (IOT), Data Sciences, Block chain, and Cyber Security, we are making significant efforts to further this cause.

P. A. College of Engineering has a 23-year history that has been rich and rewarding, and I have no doubt that it will play a significant role in the advancements of this nation and the global community as a whole in the years to come.

Mr. Abdulla Ibrahim, Managing Trustee,
P A Educational Trust (Regd.)

        </p>
       
      </div>
      <div className='ed'>     <div style={{ textAlign: "center" }}>
  <img className='chairman-name'
    src="/images/ed.jpg"
    alt="Chairman"
    // style={{
    //   marginRight:"60%",
    //   width: "550px",
    //   height: "450px",
    //   objectFit: "cover",
    //   borderRadius: "5%",
    //   border: "2px solidrgb(0, 0, 0)",
    //   marginBottom: "10px"
    // }}
  />
  <p style={{ fontWeight: "bold", fontSize: "18px", margin: "5px 0" }}>
    Mr. Abdulla Ibrahim
  </p>
  <p style={{ fontWeight:"bold",fontSize: "14px", margin: "0" }}>
    Managing Trustee,
  </p>
  <p style={{ fontSize: "14px", margin: "0" }}>
    P A Educational Trust (Regd.)
  </p>
  </div>
 
      </div>
    </div>
  );
};

export default transport;
